// Mock data for Hi-Viz Pro Kenya Limited E-commerce

export const products = [
  {
    id: 1,
    name: "Reflective Safety Vest - Class 2",
    category: "Reflective Vests",
    price: 850,
    image: "https://images.unsplash.com/photo-1771432527744-3ed62732448e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxyZWZsZWN0aXZlJTIwdmVzdHxlbnwwfHx8fDE3NzMyOTg0NDJ8MA&ixlib=rb-4.1.0&q=85",
    description: "High-visibility Class 2 reflective safety vest. DOSHS & KEBS compliant. Suitable for construction and road work.",
    specifications: "Material: Polyester mesh, Color: Orange/Yellow, Sizes: M, L, XL, XXL",
    compliance: "EN ISO 20471:2013, KEBS, DOSHS",
    inStock: true,
    featured: true
  },
  {
    id: 2,
    name: "Reflective Safety Vest - Class 3",
    category: "Reflective Vests",
    price: 1200,
    image: "https://images.unsplash.com/photo-1772456593888-1bb7cf211df0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxyZWZsZWN0aXZlJTIwdmVzdHxlbnwwfHx8fDE3NzMyOTg0NDJ8MA&ixlib=rb-4.1.0&q=85",
    description: "Premium Class 3 high-visibility vest with enhanced reflective strips. Ideal for high-risk work zones.",
    specifications: "Material: Breathable polyester, Color: Orange with reflective strips, Sizes: S-XXL",
    compliance: "EN ISO 20471:2013, KEBS, DOSHS",
    inStock: true,
    featured: true
  },
  {
    id: 3,
    name: "Safety Helmet - Orange",
    category: "Safety Helmets",
    price: 650,
    image: "https://images.unsplash.com/photo-1662309376159-b95fb193d96b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxoYXJkJTIwaGF0fGVufDB8fHx8MTc3MzI5ODQwOXww&ixlib=rb-4.1.0&q=85",
    description: "Durable hard hat with adjustable suspension system. Protects against impact and penetration.",
    specifications: "Material: ABS plastic, Weight: 350g, Adjustable headband",
    compliance: "ANSI/ISEA Z89.1, KEBS",
    inStock: true,
    featured: true
  },
  {
    id: 4,
    name: "Safety Boots - Steel Toe",
    category: "Safety Boots",
    price: 3500,
    image: "https://images.unsplash.com/photo-1613325267798-05214c4d65f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxzYWZldHklMjBib290c3xlbnwwfHx8fDE3NzMyOTg0MjZ8MA&ixlib=rb-4.1.0&q=85",
    description: "Professional steel toe safety boots with slip-resistant sole. Waterproof and oil-resistant.",
    specifications: "Material: Leather upper, steel toe cap, Sizes: 40-46",
    compliance: "ASTM F2413, KEBS",
    inStock: true,
    featured: true
  },
  {
    id: 5,
    name: "Protective Work Gloves",
    category: "Protective Gloves",
    price: 350,
    image: "https://images.unsplash.com/photo-1673294861057-4584f92b91d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHx3b3JrJTIwZ2xvdmVzfGVufDB8fHx8MTc3MzI5ODQzMHww&ixlib=rb-4.1.0&q=85",
    description: "Heavy-duty leather work gloves with reinforced palms. Ideal for construction and industrial work.",
    specifications: "Material: Premium leather, Sizes: L, XL",
    compliance: "EN 388, KEBS",
    inStock: true,
    featured: false
  },
  {
    id: 6,
    name: "Safety Goggles - Clear",
    category: "Eye Protection",
    price: 450,
    image: "https://images.unsplash.com/photo-1593854519602-687eae339d57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxzYWZldHklMjBnb2dnbGVzfGVufDB8fHx8MTc3MzI5ODQ0OHww&ixlib=rb-4.1.0&q=85",
    description: "Anti-fog safety goggles with UV protection. Comfortable fit with adjustable strap.",
    specifications: "Material: Polycarbonate lens, anti-scratch coating",
    compliance: "ANSI Z87.1, KEBS",
    inStock: true,
    featured: false
  },
  {
    id: 7,
    name: "Reflective Rain Jacket",
    category: "Reflective Wear",
    price: 2800,
    image: "https://images.unsplash.com/photo-1771432527744-3ed62732448e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxyZWZsZWN0aXZlJTIwdmVzdHxlbnwwfHx8fDE3NzMyOTg0NDJ8MA&ixlib=rb-4.1.0&q=85",
    description: "Waterproof reflective jacket for outdoor work. High-visibility with sealed seams.",
    specifications: "Material: PVC coated polyester, Sizes: M-XXL",
    compliance: "EN ISO 20471, KEBS",
    inStock: true,
    featured: false
  },
  {
    id: 8,
    name: "Ear Protection Muffs",
    category: "Ear Protection",
    price: 850,
    image: "https://images.unsplash.com/photo-1701522814501-1b548c320d5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxzYWZldHklMjBnb2dnbGVzfGVufDB8fHx8MTc3MzI5ODQ0OHww&ixlib=rb-4.1.0&q=85",
    description: "Industrial ear muffs with noise reduction rating. Comfortable padded ear cups.",
    specifications: "NRR: 28dB, Adjustable headband, Lightweight design",
    compliance: "ANSI S3.19, KEBS",
    inStock: true,
    featured: false
  }
];

export const categories = [
  { id: 1, name: "All Products", slug: "all" },
  { id: 2, name: "Reflective Vests", slug: "reflective-vests" },
  { id: 3, name: "Safety Helmets", slug: "safety-helmets" },
  { id: 4, name: "Safety Boots", slug: "safety-boots" },
  { id: 5, name: "Protective Gloves", slug: "protective-gloves" },
  { id: 6, name: "Eye Protection", slug: "eye-protection" },
  { id: 7, name: "Ear Protection", slug: "ear-protection" }
];

export const complianceStandards = [
  { name: "DOSHS", description: "Directorate of Occupational Safety and Health Services - Kenya" },
  { name: "KEBS", description: "Kenya Bureau of Standards Certified" },
  { name: "EN ISO 20471", description: "High-Visibility Warning Clothing" },
  { name: "ANSI/ISEA", description: "American National Standards Institute" }
];

// Mock user data
export const mockUsers = [
  {
    id: 1,
    email: "demo@hivizprokenya.co.ke",
    password: "demo123",
    name: "Demo User",
    phone: "+254716504759",
    isAdmin: false
  },
  {
    id: 2,
    email: "admin@hivizprokenya.co.ke",
    password: "admin123",
    name: "Admin User",
    phone: "+254716504759",
    isAdmin: true
  }
];

// Mock orders
export const mockOrders = [
  {
    id: "ORD-001",
    userId: 1,
    customerName: "Demo User",
    email: "demo@hivizprokenya.co.ke",
    phone: "+254712345678",
    items: [
      { productId: 1, productName: "Reflective Safety Vest - Class 2", quantity: 10, price: 850 },
      { productId: 3, productName: "Safety Helmet - Orange", quantity: 5, price: 650 }
    ],
    total: 11750,
    deliveryAddress: "Nairobi CBD, Kenya",
    deliveryFee: 500,
    paymentMethod: "M-Pesa",
    status: "Processing",
    date: "2025-01-10"
  }
];
